import { TrackingEvent } from '@bridebook/web/lib/track-utils/tracking-event';

export const mapEventToFacebookEvent = (event: TrackingEvent, platform: 'ios' | 'android') => {
  if (isFacebookEvent(event)) {
    return platform === 'ios'
      ? FacebookTrackingEventIOS[event]
      : FacebookTrackingEventAndroid[event];
  }
  return null;
};

const isFacebookEvent = (event: TrackingEvent): event is FacebookTrackingEvent =>
  SupportedFacebookTrackingEvents.includes(event as FacebookTrackingEvent);

const SupportedFacebookTrackingEvents = [
  TrackingEvent.SignedUp,
  TrackingEvent.CompletedOnboarding,
  TrackingEvent.LoadedSearchResults,
  TrackingEvent.ViewedSupplierProfile,
  TrackingEvent.TriggeredEnquiryForm,
  TrackingEvent.SendEnquiry,
] as const;

type FacebookTrackingEvent = (typeof SupportedFacebookTrackingEvents)[number];

const FacebookTrackingEventIOS: Record<FacebookTrackingEvent, string> = {
  [TrackingEvent.SignedUp]: 'FBSDKAppEventNameCompletedRegistration',
  [TrackingEvent.CompletedOnboarding]: 'FBSDKAppEventNameCompletedTutorial',
  [TrackingEvent.LoadedSearchResults]: 'FBSDKAppEventNameSearched',
  [TrackingEvent.ViewedSupplierProfile]: 'FBSDKAppEventNameViewedContent',
  [TrackingEvent.TriggeredEnquiryForm]: 'FBSDKAppEventNameInitiatedCheckout',
  [TrackingEvent.SendEnquiry]: 'FBSDKAppEventNameContact',
};

const FacebookTrackingEventAndroid: Record<FacebookTrackingEvent, string> = {
  [TrackingEvent.SignedUp]: 'EVENT_NAME_COMPLETED_REGISTRATION',
  [TrackingEvent.CompletedOnboarding]: 'EVENT_NAME_COMPLETED_TUTORIAL',
  [TrackingEvent.LoadedSearchResults]: 'EVENT_NAME_SEARCHED',
  [TrackingEvent.ViewedSupplierProfile]: 'EVENT_NAME_VIEWED_CONTENT',
  [TrackingEvent.TriggeredEnquiryForm]: 'EVENT_NAME_INITIATED_CHECKOUT',
  [TrackingEvent.SendEnquiry]: 'EVENT_NAME_CONTACT',
};
